function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.337 12.156L17.15 9.96l-1.433-5.347c-.12-.447-.6-.706-1.07-.582L4.662 6.706c-.47.126-.754.592-.635 1.039L7.58 21c.12.447.599.708 1.068.58l3.975-1.064-.542 2.022c-.12.447.164.913.635 1.037l8.92 2.392c.472.127.95-.133 1.07-.582l3.267-12.193c.119-.446-.165-.913-.636-1.037zM5.797 7.993l8.612-2.305 3.188 11.9-8.613 2.306-3.188-11.9zM21.244 24.31l-7.495-2.05.59-2.201 4.29-1.152c.472-.124.757-.591.637-1.038l-1.66-6.19 6.542 1.795-2.904 10.836z"
});
function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref);
}
export default SvgReports;